import { extend } from 'flarum/common/extend';
import DiscussionHero from 'flarum/forum/components/DiscussionHero';

// 给 DiscussionHero 的 items() 加一个 content item：把主帖正文渲染进 Hero 区
// 这样配合 .Page-hero 的 sticky，标题 + 主帖正文会一起吸顶
extend(DiscussionHero.prototype, 'items', function (items) {
  const discussion = this.attrs.discussion;
  const firstPost = discussion.firstPost();
  if (firstPost && firstPost.contentHtml()) {
    items.add('content', m("div", {
      className: "DiscussionHero-content",
      key: "op-content"
    }, m.trust(firstPost.contentHtml())), 0);
  }
});